import { render, staticRenderFns } from "./CardVotantePuesto.vue?vue&type=template&id=7d9ba6c9&scoped=true"
import script from "./CardVotantePuesto.vue?vue&type=script&lang=js"
export * from "./CardVotantePuesto.vue?vue&type=script&lang=js"
import style0 from "./CardVotantePuesto.vue?vue&type=style&index=0&id=7d9ba6c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9ba6c9",
  null
  
)

export default component.exports